<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="voucherTypes"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
        <v-alert type="error" :value="field.errors" style="width: 100%" v-if="field.errors">
            <li v-for="error in field.errors" v-bind:key="error">
                {{ error }}
            </li>
        </v-alert>
    </ies-form-field>
</template>

<script>
    /**
     * Allows the selection of a voucher type ID by choosing its name from
     * a selection downloaded from the API on creation
     */
    export default {
        name: 'ies-voucherType',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                voucherTypes: [],
                viewValue: parseInt(this.field.value),
            }
        },
        created:function() {
            this.getVoucherTypes();
        },
        methods: {
            getVoucherTypes:function(){
                axios.get('/api/voucher-types')
                .then(function(response){
                    console.log(response);
                    var voucherTypes = [];
                    response.data.types.forEach(function(voucherType){
                        voucherTypes.push({ text: voucherType.name, value: voucherType.voucher_type_key });
                    });
                    this.voucherTypes = voucherTypes;
                }.bind(this));
            },
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
